import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    title: {
        id: "article.rhytladder.title",
    },
    slogen: {
        id: "article.rhytladder.slogen",
    },
    description: {
        id: "article.rhytladder.description",
    },
    notKodaly: {
        id: "article.rhytladder.notKodaly",
    },
});

export default messages;
